import { Reducer } from 'redux';
import { Area } from '../../Models/Area';
import { Actions } from '../../actions/Actions';
import { WorkItemState } from '../../Models/WorkItemState';
import { CSGProduct } from '../../Models/CSGProduct';
import { EOUModel } from 'src/Models/EOUModel';

// Define the action state that the reducer expects to receive/update while processing events.
export interface DropdownDataState {
  areas: Area[];
  workItemStates: WorkItemState[];
  csgProductList: CSGProduct[];
  eous: EOUModel[];
  isDataLoaded: boolean;
}

// TODO: old state should be replacted with AuthenticationStatusState and action should be replaced with AuthenticationAction
export const reducer: Reducer<DropdownDataState> = (
  oldState: DropdownDataState = initialDropdownDataState,
  action: any
): DropdownDataState => {
  let newState: DropdownDataState;
  switch (action.type) {
    case Actions.GET_DROPDOWN_DATA:
      newState = { ...oldState };
      break;
    case Actions.SET_DROPDOWN_DATA:
      newState = JSON.parse(JSON.stringify(action.payload));
      break;
    default:
      newState = oldState;
      break;
  }
  return newState;
};

export const initialDropdownDataState: DropdownDataState = {
  areas: [],
  workItemStates: [],
  csgProductList: [],
  eous: [],
  isDataLoaded: false,
};
